module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(3), exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(1);
var style_1 = __webpack_require__(4);
var shield_1 = __webpack_require__(5);
var styles = __webpack_require__(6);
exports.PopupDirection = {
    LEFT: 'left',
    RIGHT: 'right',
    CENTER: 'center',
};
var HonestWork = /** @class */ (function (_super) {
    tslib_1.__extends(HonestWork, _super);
    function HonestWork(props) {
        var _this = _super.call(this, props) || this;
        _this.enteringTimer = null;
        _this.leavingTimer = null;
        _this.animateEntering = function () {
            _this.enteringTimer = window.setTimeout(function () {
                _this.setState({
                    animationClassname: 'enter',
                });
            }, 300);
        };
        _this.animateLeaving = function () {
            _this.leavingTimer = window.setTimeout(function () {
                _this.setState({
                    isVisible: false,
                });
            }, 300);
        };
        _this.clearAnimationTimeout = function (timerId) {
            if (timerId) {
                window.clearInterval(timerId);
            }
        };
        _this.handleAgentLinkClick = function (e) {
            if (_this.props.onAgentLinkClick) {
                _this.props.onAgentLinkClick(e);
            }
        };
        _this.handleMoreInfoClick = function (e) {
            if (_this.props.onMoreInfoClick) {
                _this.props.onMoreInfoClick(e);
            }
        };
        _this.handleContainerClick = function (e) {
            if (_this.props.onClick) {
                _this.props.onClick(e);
            }
        };
        _this.state = { isVisible: false, animationClassname: 'leave' };
        return _this;
    }
    HonestWork.prototype.render = function () {
        var _this = this;
        var _a = this.props, isPopupDisabled = _a.isPopupDisabled, isHonestWorkDisabled = _a.isHonestWorkDisabled, className = _a.className;
        return (React.createElement("div", tslib_1.__assign({ onClick: this.handleContainerClick, onMouseEnter: function () { return _this.showPopup(); }, onMouseLeave: function () { return _this.hidePopup(); } }, style_1.mergeStyles([
            styles['container'],
            className,
        ])),
            this.isPopupEnabled() && this.state.isVisible && this.renderPopup(),
            React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles(styles['icon'], isHonestWorkDisabled && styles['icon--disabled'] || '', isPopupDisabled && styles['icon--popup-disabled'] || '')),
                React.createElement(shield_1.IconShield, null))));
    };
    HonestWork.prototype.componentWillUnmount = function () {
        this.clearAnimationTimeout(this.enteringTimer);
        this.clearAnimationTimeout(this.leavingTimer);
    };
    HonestWork.prototype.isPopupEnabled = function () {
        return !this.props.isPopupDisabled && !this.props.isHonestWorkDisabled;
    };
    HonestWork.prototype.renderPopup = function () {
        var _a = this.props, direction = _a.direction, agentLink = _a.agentLink;
        return (React.createElement("div", tslib_1.__assign({}, style_1.mergeStyles([
            styles['popup-container'],
            styles["popup-container--" + direction],
            styles[this.state.animationClassname],
        ])),
            React.createElement("div", { className: styles['popup'] },
                React.createElement("div", { className: styles['popup-content'] },
                    React.createElement("div", { className: styles['popup-icon'] },
                        React.createElement(shield_1.IconShield, null)),
                    React.createElement("h3", { className: styles['title'] },
                        "\u041F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043E",
                        React.createElement("span", { className: styles['cian'] }, "\u0426\u0418\u0410\u041D")),
                    React.createElement("h4", { className: styles['subtitle'] }, "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u00AB\u200E\u0420\u0430\u0431\u043E\u0442\u0430\u044E \u0447\u0435\u0441\u0442\u043D\u043E\u00BB"),
                    React.createElement("div", { className: styles['text'] },
                        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u0442",
                        agentLink
                            ? (React.createElement("a", { target: "_blank", href: this.getAgentLink(), className: styles['agent-link'], onClick: this.handleAgentLinkClick },
                                React.createElement("span", { className: styles['agent-text'] }, "\u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0430\u0433\u0435\u043D\u0442\u0430")))
                            : React.createElement("span", { className: styles['agent-text'] }, "\u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0430\u0433\u0435\u043D\u0442\u0430")),
                    React.createElement("a", { target: "_blank", href: "//promo.cian.ru/rabotayu-chestno", className: styles['link'], onClick: this.handleMoreInfoClick }, "\u0423\u0437\u043D\u0430\u0442\u044C \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435")))));
    };
    HonestWork.prototype.getAgentLink = function () {
        var agentLink = this.props.agentLink;
        var agentLinkQuery = '';
        if (typeof agentLink === 'string') {
            agentLinkQuery = agentLink;
        }
        else if (agentLink) {
            var _a = agentLink.baseUrl, baseUrl = _a === void 0 ? '' : _a, agentId = agentLink.agentId, otherLinkProps_1 = agentLink.otherLinkProps;
            var agentLinkPropsQuery = otherLinkProps_1
                ? Object.keys(otherLinkProps_1).map(function (key) { return "&" + key + "=" + otherLinkProps_1[key]; }).join('')
                : '';
            agentLinkQuery = baseUrl + "/cat.php?engine_version=2&id_user=" + agentId + agentLinkPropsQuery;
        }
        return agentLinkQuery;
    };
    HonestWork.prototype.showPopup = function () {
        this.clearAnimationTimeout(this.leavingTimer);
        this.setState({
            isVisible: true,
            animationClassname: 'entering',
        }, this.animateEntering);
    };
    HonestWork.prototype.hidePopup = function () {
        this.clearAnimationTimeout(this.enteringTimer);
        this.setState({
            animationClassname: 'leave',
        }, this.animateLeaving);
    };
    HonestWork.defaultProps = {
        direction: exports.PopupDirection.LEFT,
    };
    return HonestWork;
}(React.Component));
exports.HonestWork = HonestWork;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isStyleProps(styleArgument) {
    if (typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
var reduce = function (acc, style) {
    if (typeof style === 'string') {
        acc.className += acc.className.length === 0
            ? style
            : " " + style;
    }
    else if (typeof style === 'object') {
        if (isStyleProps(style)) {
            acc.className += acc.className.length === 0
                ? style.className
                : " " + style.className;
            Object.assign(acc.style, style.style);
        }
        else if (Array.isArray(style)) {
            return style.reduce(reduce, acc);
        }
        else {
            Object.assign(acc.style, style);
        }
    }
    return acc;
};
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reduce, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;
//# sourceMappingURL=style.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(1);
exports.IconShield = function () { return (React.createElement("svg", { viewBox: "0 0 14 15", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11.073 2.037A29.072 29.072 0 0 1 7 0C5.833.7 4.667 1.3 3.5 1.8 2.333 2.3 1.167 2.7 0 3l.42 4.2a9 9 0 0 0 6.11 7.643L7 15l.47-.157A9 9 0 0 0 13.58 7.2L14 3a23.214 23.214 0 0 1-1.656-.493l.047.056-.16.193a35.272 35.272 0 0 0-5.158 8.364l-.262.603-.284-.594c-.604-1.264-1.82-3.006-2.744-3.98l-.186-.194 1.24-1.464.23.247A13.788 13.788 0 0 1 6.73 7.895c1.046-1.881 2.82-4.234 4.342-5.858z", fill: "currentColor", fillRule: "evenodd" }))); };


/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"honestwork_component-container-i5SoARmX1mA","entering":"honestwork_component-entering-jTqZYpVTpeC","enter":"honestwork_component-enter-29aeaakVYgW","icon":"honestwork_component-icon-keNL7j5ewwC","leave":"honestwork_component-leave-iFLoGwuUvKu","icon--disabled":"honestwork_component-icon--disabled-8LfSH1WwIEi","icon--popup-disabled":"honestwork_component-icon--popup-disabled-463Ji0yHcQO","popup-container":"honestwork_component-popup-container-g9kOomkqQ04","popup-container--left":"honestwork_component-popup-container--left-geE4ka0UmIS","popup-container--right":"honestwork_component-popup-container--right-gvEcVP3fmSo","popup-container--center":"honestwork_component-popup-container--center-8Bsn12bVks4","popup":"honestwork_component-popup-gFXkO6eDioy","popup-content":"honestwork_component-popup-content-5u654YjgR20","title":"honestwork_component-title-7RJO5bpccw8","subtitle":"honestwork_component-subtitle-aI1hc1M3FmY","cian":"honestwork_component-cian-bPnh1xI5y0q","text":"honestwork_component-text-lWs9pKJdWCI","link":"honestwork_component-link-c2Xsv4xbz2S","popup-icon":"honestwork_component-popup-icon-2RjvySja6A8","agent-link":"honestwork_component-agent-link-a8CwE317W0A","agent-text":"honestwork_component-agent-text-fy27xpPBcc2"};

/***/ })
/******/ ]);
//# sourceMappingURL=frontend-component-honestwork.js.map